// Common messages used throughout the application
export const WORKING_MAGIC_MESSAGE = 'Working magic...'
